var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FitToast',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading.show),expression:"loading.show"}],staticClass:"fit-font-30",attrs:{"icon":_vm.loading.type,"showDotLine":_vm.showDotLine}},[_c('span',[_vm._v(_vm._s(_vm.loading.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }